import React from 'react';
import { Box, Button, TextField, Typography, Paper } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { GetUserInfo, UserLogin } from '../Core/Apicall';
import { useDispatch } from 'react-redux';
import { setToken, setuserDetails } from '../Redux/Reducers/globalSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Validation Schema
const LoginSchema = Yup.object({
    email: Yup.string()
        .email('Enter a valid email address')
        .required('Email is required'),
    password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required'),
});

interface LoginFormValues {
    email: string;
    password: string;
}

function Login() {
    const initialValues: LoginFormValues = {
        email: '',
        password: '',
    };

    const dispatch = useDispatch()
    const navigate = useNavigate()

   const api = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-Type": "application/json",
        },
    });


    const getUserInfo = async (token:any, userId: string) => {
        try {
            const res = await api.get("/user/userInfo", {
                headers: {
                    Authorization: token,
                },
                params: {
                    user_id: userId,
                },
            });

            dispatch(setuserDetails(res?.data))
            navigate('/home')
            console.log("UserProfile Data -->", res);
        } catch (error: any) {
            navigate('/error')
             toast.error(error?.message || "Something went wrong");
        }
    };
    const handleSubmit = async (
        values: LoginFormValues,
        { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
    ) => {
        console.log('Login Data:', values);
        try {
            const formData = new FormData();

            formData.append("email", values.email.trim());
            formData.append("password", values.password.trim());

            const res = await UserLogin(formData);
            if (res?.status) {
                dispatch(setToken(res?.token))
                await getUserInfo(res?.token,res?.member?.user_id)
            }
        } catch (error: any) {
             toast.error(error?.message || "Something went wrong");
        }

        // API call can be made here
        // Example:
        // loginUser(values);

        setTimeout(() => {
            setSubmitting(false);
        }, 1000);
    };

    return (
        <Box
            className="d-flex justify-content-center   align-items-center"
            sx={{
                padding: 2,
                height: 'calc(100vh - 75px)'
            }}
        >
            <Paper
                className='form'
                elevation={6}
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    p: 4,
                    borderRadius: 3,
                    background: "var(--primary-color)",
                    boxShadow: '0px 0px 10px #FFFFFF'
                }}
            >
                <Typography className='fs-28 text-white fw-bold'>
                    Login
                </Typography>

                <Formik
                    initialValues={initialValues}
                    validationSchema={LoginSchema}
                    onSubmit={handleSubmit}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        isSubmitting,
                    }) => (
                        <Form>
                            <TextField
                                fullWidth
                                label="Email Address"
                                name="email"
                                type="email"
                                margin="normal"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.email && Boolean(errors.email)}
                                helperText={touched.email && errors.email}
                            />

                            <TextField
                                fullWidth
                                label="Password"
                                name="password"
                                type="password"
                                margin="normal"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.password && Boolean(errors.password)}
                                helperText={touched.password && errors.password}
                            />

                            {/* Submit Button */}
                            <Button
                                fullWidth
                                type="submit"
                                // variant="contained"
                                // size="large"
                                className='btn-yellow'
                                disabled={isSubmitting}
                                sx={{
                                    mt: 3,
                                    py: 1.2,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                }}
                            >
                                {isSubmitting ? 'Logging in...' : 'Login'}
                            </Button>
                        </Form>
                    )}
                </Formik>
            </Paper>
        </Box>
    );
}

export default Login;



